import { render, staticRenderFns } from "./AnnotationViewportImg.vue?vue&type=template&id=232923a0&scoped=true"
import script from "./AnnotationViewportImg.vue?vue&type=script&lang=js"
export * from "./AnnotationViewportImg.vue?vue&type=script&lang=js"
import style0 from "./AnnotationViewportImg.vue?vue&type=style&index=0&id=232923a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232923a0",
  null
  
)

export default component.exports